export type RangePreset =
  | "today"
  | "this_week"
  | "this_month"
  | "last_month"
  | "this_year"
  | "custom"
  | "all";

export interface DashboardRange {
  preset: RangePreset;
  from?: string; // YYYY-MM-DD, custom only
  to?: string; // YYYY-MM-DD, custom only
}

export const PRESET_LABELS: Record<RangePreset, string> = {
  today: "Today",
  this_week: "This week",
  this_month: "This month",
  last_month: "Last month",
  this_year: "This year",
  custom: "Custom",
  all: "All time",
};

// Presets shown in the dropdown, in order. "custom" is handled separately.
export const PRESET_OPTIONS: RangePreset[] = [
  "today",
  "this_week",
  "this_month",
  "last_month",
  "this_year",
];

export const DEFAULT_RANGE: DashboardRange = { preset: "this_month" };

// All-time (unfiltered). Used by the Orders page so its tab counts match the
// unfiltered order list. Intentionally NOT in PRESET_OPTIONS — the dashboard
// dropdown should not offer it.
export const ALL_TIME_RANGE: DashboardRange = { preset: "all" };

/** Query params sent to the API for a given range. */
export function rangeToParams(range: DashboardRange): Record<string, string> {
  const params: Record<string, string> = { preset: range.preset };
  if (range.preset === "custom") {
    if (range.from) params.from = range.from;
    if (range.to) params.to = range.to;
  }
  return params;
}

/** Stable string used in react-query keys so each range caches separately. */
export function rangeKey(range: DashboardRange): string {
  return range.preset === "custom"
    ? `custom:${range.from ?? ""}_${range.to ?? ""}`
    : range.preset;
}

/** Human-readable label for the active range (used near the stat cards). */
export function rangeLabel(range: DashboardRange): string {
  if (range.preset === "custom") {
    if (range.from && range.to) return `${range.from} → ${range.to}`;
    return "Custom";
  }
  return PRESET_LABELS[range.preset];
}
